module.exports = __webpack_public_path__ + "ionicons.24712f6c47821394fba7.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ionicons/fonts/ionicons.ttf?v=2.0.0
// module id = 1197
// module chunks = 8